import React from 'react';

import {
  BarChartCard,
  LabelCard,
  PieChartCard,
  TableCard,
  XYChartCard,
} from '@/components/dataVisualizations/components';

import { ReportCardProps } from './types';

export const ReportCard = ({
  cellFormatter,
  clearFilters,
  columnFormatter,
  description,
  query,
  sx,
  title,
  variant,
}: ReportCardProps) => {
  switch (variant.type) {
    case 'label': {
      return (
        <LabelCard
          clearFilters={clearFilters}
          columnFormatter={columnFormatter}
          description={description}
          query={query}
          sx={sx}
          title={title}
        />
      );
    }
    case 'bar_chart': {
      return (
        <BarChartCard
          clearFilters={clearFilters}
          columnFormatter={columnFormatter}
          description={description}
          query={query}
          sx={sx}
          title={title}
          variantProps={variant}
        />
      );
    }
    case 'pie_chart': {
      return (
        <PieChartCard
          clearFilters={clearFilters}
          columnFormatter={columnFormatter}
          description={description}
          query={query}
          sx={sx}
          title={title}
          variantProps={variant}
        />
      );
    }
    case 'table': {
      return (
        <TableCard
          cellFormatter={cellFormatter}
          clearFilters={clearFilters}
          columnFormatter={columnFormatter}
          description={description}
          query={query}
          sx={sx}
          title={title}
        />
      );
    }
    case 'xy_chart': {
      return (
        <XYChartCard
          clearFilters={clearFilters}
          columnFormatter={columnFormatter}
          description={description}
          query={query}
          sx={sx}
          title={title}
          variantProps={variant}
        />
      );
    }
    default: {
      throw new Error('Assign a valid widget type in the display configuration');
    }
  }
};
